import * as React from "react";
import {Grid} from "react-bootstrap";
import {ActionBar} from "../common/ui/actionbar/ActionBar";
import {MasterDetailLayout} from "../common/ui/layouts/MasterDetailLayout";
import {PublishProductInServiceButton} from "./CreateServiceButton";
import {ServiceFilter} from "./filter/ServiceFilter";
import {Service} from "./model";
import {ServiceList} from "./ServiceList";
import {ServiceListDetailSection} from "./ServiceListDetailSection";
import {SortDirection, SortSettings, updateSortIndicators} from "../common/ui/table/model";
import {COLUMN_SORT_SETTINGS_SERVICES, localRepository} from "../common/LocalRepository";

interface ServicePageState {
  selection: Service[];
  sortSettings?: SortSettings | null;
}

export class ServicesPage extends React.Component<any, ServicePageState> {

  constructor(props) {
    super(props);
    this.state = {
      selection: [],
      sortSettings: null,
    };
  }

  componentDidMount() {
    let sortSettings: SortSettings = localRepository.getOptions<SortSettings>(COLUMN_SORT_SETTINGS_SERVICES);
    if (!sortSettings) {
      sortSettings = {
        column: "title",
        direction: SortDirection.asc
      }
      localRepository.setOptions(COLUMN_SORT_SETTINGS_SERVICES, sortSettings);
    }
    this.setState({sortSettings});
  }

  handleRowSelect = (selection: Service[]) => {
    this.setState(Object.assign({}, this.state, {selection}));
  }

  clearSelection = () => this.handleRowSelect([]);

  onSortChange = (columnKey: string) => {
    this.clearSelection();
    this.setState((prevState) => {
      if (prevState.sortSettings.column === columnKey) {
        const nextDir = prevState.sortSettings.direction === SortDirection.asc ? SortDirection.desc : SortDirection.asc;
        const sortSettings: SortSettings = {column: columnKey, direction: nextDir};
        localRepository.setOptions(COLUMN_SORT_SETTINGS_SERVICES, sortSettings);
        updateSortIndicators(sortSettings.column, sortSettings.direction, columnKey);
        return {sortSettings}
      }
      localRepository.setOptions(COLUMN_SORT_SETTINGS_SERVICES, {column: columnKey, direction: SortDirection.asc});
      updateSortIndicators(columnKey, SortDirection.asc, columnKey);
      return {sortSettings: {column: columnKey, direction: SortDirection.asc}};
    });
  }

  render() {
    const {selection} = this.state;
    const noSelection = selection.length === 0;

    const masterPane = (
        <Grid fluid={true}>
          <ActionBar>
            <PublishProductInServiceButton/>
          </ActionBar>

          <ServiceFilter notifyFilterChanged={this.clearSelection}/>

          <div> {/* This empty div is necessary! it's used by ControlRoomTable to calculate its dimensions.*/}
            <ServiceList onRowSelect={this.handleRowSelect}
                         clearSelection={noSelection}
                         sortSettings={this.state?.sortSettings}
                         onSortChange={this.onSortChange}
            />
          </div>

        </Grid>
    );

    const detailPane = <ServiceListDetailSection selection={selection}/>;

    return (
        <div>
          <MasterDetailLayout masterPane={masterPane} detailPane={detailPane}/>
        </div>
    );
  }
}
